export default "__VITE_ASSET__8d4e6eef__"